<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="2">
                  <label class="mr-sm-2" for="sSearchTime">Report Time (HH:mm)</label>
                  <b-input id="sSearchTime" type="time" placeholder="" v-model.trim="sSearchTime" :state="$v.sSearchTime.$error?false:null" @blur.native="$v.sSearchTime.$touch"></b-input>
                  <div v-if="$v.sSearchTime.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.sSearchTime.required">Please select Report Search Time</div>
                  </div>
                </b-col>
                <b-col sm="2">
                  <label class="mr-sm-2" for="sBrand">Brand</label>
                  <b-form-select id="sBrand" :plain="true" :options="brandOption" v-model="sBrand" text-field="Code" value-field="Code">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="mr-sm-2" for="sGameType">Game Type</label>
                  <b-form-select id="sGameType" :plain="true" :options="gameTypeOption" v-model="sGameType" text-field="Name" value-field="Name">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="mr-sm-2" for="sTurnoverThreshold">Turnover Threshold (%)</label>
                  <b-input id="sTurnoverThreshold" type="number" min="0" placeholder="" v-model.trim="sTurnoverThreshold" @blur.native="$v.sTurnoverThreshold.$touch"></b-input>
                </b-col>
                <b-col sm="2">
                    <label class="mr-sm-2" for="sNetWinThreshold">NetWin Threshold (%)</label>
                    <b-input id="sNetWinThreshold" type="number" placeholder="" v-model.trim="sNetWinThreshold" @blur.native="$v.sNetWinThreshold.$touch"></b-input>
                  </b-col>
                <b-col sm="2" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search" :disabled="$v.sSearchTime.$invalid"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class="fa fa-bar-chart"></i> Game Trend Report</h5>
            <div class="clearfix"></div>
            <h6><strong>Netwin <span class="text-danger">-ve</span> = Member Win</strong></h6>
            <h6><strong>Netwin <span class="text-success">+ve</span> = Member Loose</strong></h6>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(Turnover)="data">
                <span>Last Hour: {{  format(data.item.LastTurnover, '0,0.00') }}</span><br/>
                <span>
                  Current Hour: {{ format(data.item.Turnover, '0,0.00') }}
                  <b-badge v-if="data.item.TurnoverTrend > 0" variant="success">({{ format(data.item.TurnoverTrend, '0,0.00') }}%)</b-badge>
                  <b-badge v-else variant="warning">({{ format(data.item.TurnoverTrend, '0,0.00') }}%)</b-badge>
                </span>
              </template>
              <template v-slot:cell(NetWin)="data">
                <span>Last Hour: {{ format(data.item.LastNetWin, '0,0.00') }}</span><br/>
                <span>
                  Current Hour: {{ format(data.item.NetWin, '0,0.00') }}
                  <b-badge v-if="data.item.IsHouseWinning" variant="success">({{ format(data.item.NetWinTrend, '0,0.00') }}%)</b-badge>
                  <b-badge v-else variant="danger">({{ format(data.item.NetWinTrend, '0,0.00') }}%)</b-badge>
                </span>
              </template>
              <template v-slot:row-details="data">
                <game-trend-detail :details="data.item.details"/>
              </template>
              <template v-slot:cell(Action)="data">
                <b-btn variant="primary" class="btn-sm" @click="viewDetail(data.item)">See Detail</b-btn>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { Events } from '../../../../events.js'
import numeral from 'numeral'
import VueNotifications from 'vue-notifications'
import GameTrendDetail from './GameTrendReportDetailTable'
const moment = require('moment-timezone')

export default {
  name: 'game-trend-report-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'Action', label: 'Action', thStyle: { width: '100px' }},
        {key: 'GameType', label: 'Game Type'},
        {key: 'Brand', label: 'Brand'},
        {key: 'GameName', label: 'Game Name'},
        {key: 'Turnover', label: 'Turnover'},
        {key: 'NetWin', label: 'NetWin'}
      ],
      perPage: 50,
      currentPage: 1,
      rowCount: 0,
      brandOption: [],
      gameTypeOption: [],
      sSearchTime: moment().tz('Asia/Taipei').format('HH:00:00'),
      sBrand: null,
      sGameType: null,
      sTurnoverThreshold: '',
      sNetWinThreshold: ''
    }
  },
  components: {
    GameTrendDetail
  },
  validations: {
    sSearchTime: {
      required
    }
  },
  methods: {
    getRowCount () {
      return this.rowCount
    },
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    validateDateRange () {
      return !(Math.abs(moment(this.sStartTime).diff(this.sEndTime, 'months', true)) > this.reportDateLimit)
    },
    async getGameType () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.post(this.API_ENDPOINT + '/game/getType', { headers: { 'Content-Type': 'application/json' } })
        this.gameTypeOption = data.list
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async getBrand () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.post(this.API_ENDPOINT + '/game/v2/platform/getList', { headers: { 'Content-Type': 'application/json' } })
        this.brandOption = data.list
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async search () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.post(this.API_ENDPOINT + '/report/game/risk/trend', {
          time: this.sSearchTime,
          turnoverThreshold: this.sTurnoverThreshold,
          netwinThreshold: this.sNetWinThreshold,
          brand: this.sBrand || '',
          gameType: this.sGameType || ''
        }, { headers: { 'Content-Type': 'application/json' } })
        this.items = data.result
        this.rowCount = data.rowCount
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    viewDetail (item) {
      if (item._showDetails) {
        item._showDetails = false
      } else {
        if (item.details) {
          item._showDetails = true
        } else {
          item.details = item.MemberDetail
          this.items.forEach(x => { this.$set(x, '_showDetails', false) })
          this.$set(item, '_showDetails', true)
        }
      }
    }
  },
  created () {
    this.getBrand()
    this.getGameType()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report/risk/game/GameTrendReportTable.vue